import { render, staticRenderFns } from "./ModalEndorsement.vue?vue&type=template&id=62bf7f22&scoped=true&"
import script from "./ModalEndorsement.vue?vue&type=script&lang=js&"
export * from "./ModalEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./ModalEndorsement.vue?vue&type=style&index=0&id=62bf7f22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf7f22",
  null
  
)

export default component.exports